import EqxAlert from './EqxAlert/EqxAlert';

const EqxError = function (props: { error: string; icon?: string }) {
    return <EqxAlert variant="danger" icon={props.icon}>{props.error}</EqxAlert>
}
export default EqxError
